import { jsx, jsxs } from 'react/jsx-runtime';
import { useState, useContext, useEffect } from 'react';
import { InputAdornment, IconButton, Box, Typography, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { IconContext } from '@plumeuk/shapeshift-identity';

const replaceAll = (str, find, replace) => {
    // Escape special characters in `find` using a regular expression
    const escapedFind = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // Create a regular expression with global flag to replace all occurrences
    const regex = new RegExp(escapedFind, "g");
    // Use the replace method with the regular expression
    return (str ?? "").replace(regex, replace);
};

const useStyles = makeStyles()((_theme, { hasError, valid }) => ({
    inputText: {},
    input: {
        border: valid ? "1px solid #d1d1d1" : "1px solid red",
        padding: "10px 20px",
        marginTop: "8px",
        width: "100%",
        boxSizing: "border-box"
    },
    label: {},
    errorMessage: {
        maxHeight: hasError ? 50 : 0,
        color: "#f30000",
        fontSize: "16px",
        boxSizing: "border-box",
        transition: "max-height 0.15s ease-out",
        "& p": {
            paddingTop: "5px"
        }
    }
}));
const InputText = ({ className, label, value, containerProps, error, onValidate, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);
    const valid = error === undefined;
    const { classes, cx } = useStyles({ hasError: !!error, valid });
    const { visibilityIcon, visibilityOffIcon } = useContext(IconContext);
    useEffect(() => {
        if (error !== undefined) {
            onValidate?.();
        }
    }, [value]);
    const inputProps = {
        disableUnderline: true,
        autoCapitalize: "none",
        autoComplete: "off"
    };
    if (props.type === "password") {
        inputProps["endAdornment"] = (jsx(InputAdornment, { position: "end", children: jsx(IconButton, { "data-test-id": "input-text-show-password-button", onClick: () => setShowPassword((prev) => !prev), edge: "end", children: showPassword ? visibilityIcon : visibilityOffIcon }) }));
    }
    return (jsxs(Box, { className: cx(classes.inputText, className), ...containerProps, children: [label && jsx(Typography, { className: classes.label, children: label }), jsx(TextField, { className: classes.input, id: "input-text", variant: "standard", autoComplete: 'off', InputProps: { ...inputProps, ...props.InputProps }, value: value, inputProps: {
                    "data-test-id": "text-input-" + (label ? replaceAll(label?.toLocaleLowerCase(), " ", "-") : ""),
                    autoCapitalize: "none",
                    autoCorrect: "off"
                }, onBlur: e => {
                    props?.onBlur?.(e);
                    onValidate?.();
                }, ...props, type: props.type === "password" && showPassword ? "text" : props.type }), jsx("div", { className: classes.errorMessage, children: jsx("p", { children: error ?? " " }) })] }));
};

export { InputText };
